export default function DescriptionModal({ show, title, description, onClose }) {
    if (!show) return null; // evita render innecesario

    return (
        <>
            {/* BACKDROP */}
            <div className="modal-backdrop fade show"></div>
            <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fs-5">{title}</h5>
                            <button type="button" className="btn-close" onClick={onClose} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h1 className='text-center mb-3 text-info'><i className="bi bi-info-circle-fill"></i></h1>
                            <p className='text-start mt-4 mb-3'>{description}</p>
                            <div className='text-end'>
                                <button type="button" className="btn btn-primary" onClick={onClose} data-bs-dismiss="modal">Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}